import React from 'react';
import { ALL_FILTER_VALUE } from './filterValues';

export const CUSTOMER_OPTIONS = [
    {
        label: <span data-e2e='performance_all-audiences_dropdown-item'>All audiences</span>,
        value: ALL_FILTER_VALUE
    },
    {
        label: <span data-e2e='performance_new-customers_dropdown-item'>New customers</span>,
        value: 'new'
    },
    {
        label: <span data-e2e='performance_returning-customers_dropdown-item'>Returning customers</span>,
        value: 'returning'
    }
];

export const CUSTOMER_EXCLUDED_METRICS = ['audience', 'views', 'interactions'];
